import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
    addProductCategory,
  addTages,
  deleteProdcutCategory,
  getAllCategory,
  getAllTage,
  getCategoryParentId,
  getCategoryType,
  updateProductCategory,
  upDateTages,
} from "./ProductRepo";
import { toast } from "react-toastify";
import { showToast } from "../../utils/toastUtils";

interface GetProductInterface {
  enable: boolean;
  params: {
    parentCategoryId?: number | null;
    categoryId?: number | null;
    orgUnitId?: number | null;
    search?: string;
    page?: number;
    limit?: number;
  };
}

export const useGetProduct = ({
  enable = false,
  params,
}: GetProductInterface) => {
  return useQuery({
    queryKey: ["GET_ALL_CATEGORIES",params],
    queryFn: () => getAllCategory(params),
    retry: false,
    enabled: enable,
  });
};

export const useCategoryParentID = ({
  enable = false,
}: {
  enable: boolean;
}) => {
  return useQuery({
    queryKey: ["GET_CATEGORY_PARENT_ID"],
    queryFn: getCategoryParentId,
    retry: false,
    enabled: enable,
  });
};


export const useCategoryType  = ({enable=false})=>{
  return useQuery({
    queryKey:['GET_CATEGORY_TYPE'],
    queryFn:getCategoryType,
    enabled:enable,
    retry:false,
  })
}



export const useAddProductCategory =()=>{
    const queryClient = useQueryClient();
    return  useMutation({
        mutationFn:({ReqBody}:{ReqBody:any})=>addProductCategory({ReqBody}),
        onSuccess:()=>{

          showToast.success('Category Added successfully!')
         queryClient.invalidateQueries({queryKey:['GET_ALL_CATEGORIES']})
        },
        onError:(error:any)=>{
           console.log('Failed to Add',error.message);
           showToast.error('Failed to add the new Category. Please try agian');
        }
    })
}





export const  useUpdateProductCAategory=()=>{
  const queryClient = useQueryClient();
  
  return useMutation({
     mutationFn:({ReqBody,id}:{ReqBody:any, id: number | undefined})=>updateProductCategory({ReqBody,id}),      
     onSuccess:()=>{
      showToast.success('Category Updated successfully!')
        queryClient.invalidateQueries({queryKey:['GET_ALL_CATEGORIES']})
     },
     onError:(error:any)=>{
      console.log('Failed to upadate  Please try agin later',error.message);
      showToast.error(error.message);
     }
    
  })
}





export const useDeleteProductCategory = ()=>{
  const queyClient = useQueryClient();

  return useMutation({
    mutationFn:({id}:{id:number})=>deleteProdcutCategory(id),
    onSuccess:()=>{
      showToast.success('Category Deleted Successfully!')
       queyClient.invalidateQueries({queryKey:['GET_ALL_CATEGORIES']});
    },    
    onError: (error: any) => {
      showToast.error('Category Deleted Successfully')
    }
  })
}




/************************************************* TAGES *****************************************************/

interface TageInterface {
  enable: boolean;
  params: {
    id?: number | null;
    search?: string;
    page?: number;
    limit?: number;
  };
}

export const useGETAllTage = ({ enable = false, params }: TageInterface) => {
  return useQuery({
    queryKey: ["GET_ALL_TAGES", params],
    queryFn: () => getAllTage(params),
    retry: false,
    enabled: enable,
  });
};

interface ReqBody {
    tag_name: string
}

export const useAddTAges = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ ReqBody }: { ReqBody: any }) => addTages({ ReqBody }),
    onSuccess: () => {
      showToast.success("Added successfully!",)
      queryClient.invalidateQueries({ queryKey: ["GET_ALL_TAGES"] });
    },

    onError: (error: any) => {
      console.log("Failed to Add", error.message);
      showToast.error("Failed to add the Tage Please  try Again");
    },
  });
};





export const useUpdateTag = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ ReqBody, id }: { ReqBody: any; id: number }) =>
    upDateTages({ ReqBody, id }),
    onSuccess: () => {
      showToast.success("Update Successfully!")
      queryClient.invalidateQueries({ queryKey: ["GET_ALL_TAGES"] });
    },
    onError: (error: any) => {
      console.log("Failed to update", error.message);
      toast.error("Failed to Update Tag.Please try agin");
    },
  });
};
